/**
 * Calculate the number of lines needed for the textarea based on content
 * Accounts for both explicit newlines and text wrapping
 */
export const calculateLineCount = (text: string): number => {
  if (!text) return 1;

  // Count explicit newlines
  const explicitLines = text.split("\n").length;

  // Estimate wrapped lines (rough calculation based on character width)
  // Assuming ~100 characters per line at text-lg size
  const charsPerLine = 100;
  const totalLines = text.split("\n").reduce((total, line) => {
    return total + Math.max(1, Math.ceil(line.length / charsPerLine));
  }, 0);

  return Math.min(10, Math.max(explicitLines, totalLines));
};

/**
 * Calculate character count for the input
 */
export const calculateCharacterCount = (text: string): number => {
  return text.length;
};

/**
 * Check if the input has meaningful text content
 */
export const hasInputText = (text: string): boolean => {
  return text.trim().length > 0;
};
